import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import { styled } from '@mui/material/styles';
import NumberFormat from 'react-number-format';

type Props = {
    amount?: number;
    selectedCurrency?: string;
    currencies: string[];
    placeholder: string;
    setAmount(amount: number): void;
    setSelectedCurrency(currency: string): void;
};

const AmountField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderRight: 'none',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }
    },
    width: 150
});

const CurrencyField = styled(Select<string>)({
    borderLeft: 'none',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    minWidth: 120
});
export const CurrencyInput = ({
    amount,
    setAmount,
    placeholder,
    currencies,
    selectedCurrency,
    setSelectedCurrency
}: Props) => {
    const handleSetSelectedCurrency = (e: SelectChangeEvent<string>) => {
        setSelectedCurrency(e.target.value);
    };

    return (
        <Grid container>
            <Grid item>
                <NumberFormat
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    customInput={AmountField as any}
                    value={amount}
                    onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source === 'event') {
                            if (values.value === '') {
                                setAmount(0);
                            }

                            if (values.floatValue != null) {
                                setAmount(values.floatValue);
                            }
                        }
                    }}
                    placeholder={placeholder}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                />
            </Grid>
            <Grid item>
                <FormControl>
                    <InputLabel>Currency</InputLabel>
                    <CurrencyField
                        label="Currency"
                        value={selectedCurrency ?? ''}
                        onChange={handleSetSelectedCurrency}
                    >
                        {currencies.map(cur => (
                            <MenuItem key={cur} value={cur}>
                                {cur}
                            </MenuItem>
                        ))}
                    </CurrencyField>
                </FormControl>
            </Grid>
        </Grid>
    );
};
